"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const loadYouTubeVideoByUrl_1 = require("../../utils/loadYouTubeVideoByUrl");
const els_1 = require("./els");
function noVideo() {
    els_1.THUMBNAILED_VIDEO_ROOT.remove();
}
(async () => {
    let swapButtonPressed = false;
    const youtubeLink = els_1.YOUTUBE_LINK_EL.textContent;
    if (!youtubeLink) {
        noVideo();
        return;
    }
    try {
        new URL(youtubeLink);
    }
    catch (cause) {
        noVideo();
        throw new Error(`YouTube link is invalid: ${youtubeLink}`, { cause });
    }
    els_1.YOUTUBE_LINK_EL.remove();
    const embedDiv = document.createElement("div");
    els_1.THUMBNAILED_VIDEO_ROOT.append(embedDiv);
    const player = await (0, loadYouTubeVideoByUrl_1.loadYouTubeVideoByUrl)(embedDiv, youtubeLink, {
        playerVars: {
            rel: 0,
        },
    });
    const iframe = player.getIframe();
    const w = parseInt(iframe.width) || 1;
    const h = parseInt(iframe.height) || w;
    const aspectRatio = h / w;
    function play() {
        if (swapButtonPressed)
            return;
        swapButtonPressed = true;
        iframe.style.visibility = "visible";
        player.playVideo();
        els_1.THUMBNAIL_IMG.remove();
        els_1.PLAY_BUTTON.remove();
        els_1.THUMBNAILED_VIDEO_ROOT.style.paddingBottom = `${100 * aspectRatio}%`;
        els_1.THUMBNAILED_VIDEO_ROOT.style.height = "0";
    }
    els_1.PLAY_BUTTON.addEventListener("click", play);
})();
